<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Multiselect from 'vue-multiselect'
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import afiliacionSistemaRiesgosAPI from "@/services/standards/afiliacionSistemaRiesgos/afiliacionSistemaRiesgosAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "1.1.4 Afiliación al Sistema General de Riesgos Laborales ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
    Multiselect,
  },
  data() {
    return {
      title: "1.1.4 Afiliación al Sistema General de Riesgos Laborales ",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.1.4 Afiliación al Sistema General de Riesgos Laborales ",
          active: true,
        },
      ],
      lista: [],

      file: null,

      afiliacion: {
        contract_type: null,
        select_period: null,
        file: null,
        observations: null,
        employee_id: [],
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      afiliacionContratista: {
        contract_type: null,
        select_period: null,
        file: null,
        observations: null,
        employee_id: [],
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      trainingList: [],
      employee: [],

      submitted: false,

      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading1: true,
      loading2: true,
      loading3: true,

      item: null,
      selected: [],
      allSelected: false,
      userIds: [],

      itemData: null,

      optionss: ['Vuex', 'Vue', 'Vuelidate', 'Vue-Multiselect', 'Vue-Router'],

      options: [
        {
          id: 1,
          description: "Planta",
        },
        {
          id: 2,
          description: "Aprendiz",
        },
        {
          id: 3,
          description: "Contratista",
        },
      ],
    };
  },
  validations: {
    program: {
      induction_date: {
        required,
      },
      induction_theme: {
        required,
      },
    },
  },

  methods: {

    selectAll: function () {
      this.userIds = [];
      if (this.allSelected) {
        for (user in this.employee) {
          this.userIds.push(this.employee[user].id.toString());
        }
      }
    },
    select: function () {
      this.allSelected = false;
    },

    getItemData() {
      ItemAPI.getItems(10)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },


    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      afiliacionSistemaRiesgosAPI.getShow(this.$route.params.id)
        .then((response) => {
          this.loading = false
          this.afiliacion = {
            contract_type: response.data.contract_type,
            select_period: response.data.select_period,
            file: response.data.file,
            observations: response.data.observations,
            employee_id: response.data.employee_id,
          };
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = await this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = ""
        let name = ""
        let contractName = ""

        if (this.afiliacion.contract_type === 1) {
          contractName = "Empleado"
        } else if (this.afiliacion.contract_type === 2) {
          contractName = "Empleado-Aprendiz"
        } else {
          contractName = "Contratista"
        }

        if (this.file === null) {
          name = this.getFile(this.afiliacion.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/1.1.4/${contractName}/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/1.1.4/${contractName}/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.afiliacion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        afiliacionSistemaRiesgosAPI.update(this.$route.params.id, {
          companies_id: this.$store.getters["company/getCompany"].id,
          contract_type: this.afiliacion.contract_type,
          select_period: this.afiliacion.select_period,
          file: this.afiliacion.file,
          observations: this.afiliacion.observations,
          employee_id: this.afiliacion.employee_id,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 4,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha actualizado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000)
                this.$router.go(-1)
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido actualizar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          }).catch((error) => {
            console.log(error);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "Error",
            text: "¡No se ha podido actualizar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    async saveContratista() {
      this.submitted = true;
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        afiliacionSistemaRiesgosAPI.save(this.afiliacion)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 4,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha actualizado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000)
                this.$router.go(-1)
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido actualizar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "Error",
            text: "¡No se ha podido actualizar!",
            icon: "warning",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 10)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        const url = 'https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/Formato/1.2.2-Lista-de-asistencia.docx'
        window.location.href = url
      } catch (error) {
        console.log(error);
      }
    },

    getContratistas() {
      afiliacionSistemaRiesgosAPI.getContratistas(this.companyID)
        .then((response) => {
          this.loading = false
          this.trainingList = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    getEmpleados() {
      afiliacionSistemaRiesgosAPI.getEmpleados(this.companyID)
        .then((response) => {
          this.loading = false
          this.employee = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getContratistas();
    this.getEmpleados();
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1 && classificationID <= 4">
          <div class="card">
            <div class="card-body">

              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12">

                  <b-form-group class="col-md-6 px-2" label="Tipo de contrato" label-for="theme">
                    <b-form-select required id="theme" v-model="afiliacion.contract_type"
                      v-on:change="getDataTraining()" :class="{
                        'is-invalid': $v.program.induction_theme.$error && submitted,
                      }">
                      <b-form-select-option v-for="(item, index) in options" :key="index" :value="item.id">
                        {{ item.description }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.program.induction_theme.$error">
                      <small v-if="!$v.program.induction_theme.required" class="text-danger">
                        <b>El tema de capacitación es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group v-if="afiliacion.contract_type === 3" class="col-md-6 px-2" label="Contratista"
                    label-for="theme">
                    <b-form-select disabled id="theme" v-model="afiliacion.employee_id" v-on:change="getDataTraining()"
                      :class="{
                        'is-invalid': $v.program.induction_theme.$error && submitted,
                      }">
                      <b-form-select-option v-for="(item, index) in trainingList" :key="index" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.program.induction_theme.$error">
                      <small v-if="!$v.program.induction_theme.required" class="text-danger">
                        <b>El tema de capacitación es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group v-if="afiliacion.contract_type != 3" class="col-md-6 px-2" label="Empleado"
                    label-for="theme">
                    <b-form-select disabled id="theme" v-model="afiliacion.employee_id" v-on:change="getDataTraining()"
                      :class="{
                        'is-invalid': $v.program.induction_theme.$error && submitted,
                      }">
                      <b-form-select-option v-for="(item, index) in employee" :key="index" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.program.induction_theme.$error">
                      <small v-if="!$v.program.induction_theme.required" class="text-danger">
                        <b>El tema de capacitación es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                </div>

                <div class="form-row col-12">

                  <b-form-group class="col-md-6 px-2" label="Seleccionar período" label-for="mes">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="afiliacion.select_period"
                      type="month" id="hora" placeholder="FEcha"></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir evidencia de pago de ARL" label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="file" ref="file" name="file"
                      browse-text="Buscar"
                      :placeholder="afiliacion.file ? getFile(afiliacion.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="afiliacion.observations">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
